// extracted by mini-css-extract-plugin
export default {"skeletonMobile":"MobileSkeleton_skeletonMobile__sODYJ"};